export const manufacturingFields = [
  "work_system_costs_manufacturing_step_part",
  "labour_costs_manufacturing_step_part",
  "setup_costs_manufacturing_step_part",
  "tool_and_fixture_costs_manufacturing_step_part",
  "residual_manufacturing_overhead_costs_manufacturing_step_part",
  "interest_costs_of_circulating_stocks_manufacturing_step_part",
  "manufacturing_scrap_costs_manufacturing_step_part",
  "manufacturing_costs_manufacturing_step_part"
];

export const manufacturingSummaries = [
  "manufacturing_costs_manufacturing_step_part"
];
